export const HANDOFF_LABEL = 'Hand over to Agent';
export const END_FLOW_LABEL = 'End flow';

export function isAgentHandoffLabel(label) {
  return label === HANDOFF_LABEL;
}

export function isTerminalWorkflowLabel(label) {
  return label === END_FLOW_LABEL || label === HANDOFF_LABEL;
}

export function terminalWorkflowSublabel(label) {
  if (label === HANDOFF_LABEL) return 'AI Agent neemt vanaf hier dynamisch over';
  if (label === END_FLOW_LABEL) return 'Stops the workflow';
  return '';
}
